/* src/app/components/ai-voice/ai-voice.component.scss */
:host {
  height: 100vh;
  background: #fff;
}
app-page-header .page-title {
  font-size: 0.9rem;
}
app-page-header .page-title .icon {
  font-size: 0.85rem;
}
app-page-header .pull-right > span:first-child {
  font-size: 0.75rem !important;
}
app-page-header .pull-right .radio-group .radio {
  min-width: 80px;
  margin: 0.15rem;
}
app-page-header .pull-right .radio-group .radio label {
  font-size: 0.75rem !important;
}
.app-container {
  position: absolute;
  width: 100%;
  height: 80%;
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
  background: #f9fafb;
}
.app-container .main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.app-container {
}
.app-container .chat-header {
  display: flex;
  align-items: center;
  height: 90px;
}
.app-container .ai-bars {
  display: flex;
  gap: 10px;
  align-items: center;
  height: 60px;
}
.app-container .ai-bars span {
  width: 8px;
  height: 14px;
  background: #999;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.app-container {
}
.app-container .ai-bars.idle span {
  height: 12px;
  background: #bbb;
}
.app-container {
}
.app-container .ai-bars.listening span {
  animation: listeningWave 1s infinite ease-in-out;
  background: #4caf50;
}
.app-container .ai-bars.listening span:nth-child(1) {
  animation-delay: 0s;
}
.app-container .ai-bars.listening span:nth-child(2) {
  animation-delay: 0.2s;
}
.app-container .ai-bars.listening span:nth-child(3) {
  animation-delay: 0.4s;
}
.app-container .ai-bars.listening span:nth-child(4) {
  animation-delay: 0.6s;
}
@keyframes listeningWave {
  0%, 100% {
    height: 16px;
  }
  50% {
    height: 50px;
  }
}
.app-container {
}
.app-container .ai-bars.speaking span {
  animation: speakingWave 0.5s infinite ease-in-out;
  background: #2196f3;
}
.app-container .ai-bars.speaking span:nth-child(1) {
  animation-delay: 0s;
}
.app-container .ai-bars.speaking span:nth-child(2) {
  animation-delay: 0.1s;
}
.app-container .ai-bars.speaking span:nth-child(3) {
  animation-delay: 0.2s;
}
.app-container .ai-bars.speaking span:nth-child(4) {
  animation-delay: 0.3s;
}
@keyframes speakingWave {
  0%, 100% {
    height: 20px;
  }
  50% {
    height: 60px;
  }
}
.app-container {
}
.app-container .bot-wrapper {
  width: 50%;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  border-radius: 1rem;
  overflow: hidden;
  z-index: 10;
  position: fixed;
  bottom: 0;
}
.app-container .bot-wrapper .caption-wrapper {
  flex: 1;
  overflow-y: auto;
  background: #f9fafb;
  padding: 1rem;
}
.app-container .bot-wrapper .caption-wrapper .caption-line {
  font-size: 0.95rem;
  line-height: 1.4;
  color: #374151;
  margin-bottom: 0.5rem;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  transition: background 0.25s ease;
}
.app-container .bot-wrapper .caption-wrapper .caption-line:hover {
  background: #f3f4f6;
}
.app-container .bot-wrapper {
}
.app-container .bot-wrapper .btn-actions {
  display: flex;
  justify-content: center;
  padding: 0.75rem 1rem;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}
.app-container .bot-wrapper .btn-actions .icon-btn {
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem;
  border-radius: 50%;
  transition: background 0.2s ease;
}
.app-container .bot-wrapper .btn-actions .icon-btn:hover {
  background: #f3f4f6;
}
.app-container .bot-wrapper .btn-actions .icon-btn img {
  display: block;
}
.app-container .bot-wrapper .btn-actions .close-btn:hover {
  background: #fee2e2;
}
.app-container .bot-wrapper .btn-actions .mic-btn .pulse-ring {
  position: absolute;
  width: 44px;
  height: 44px;
  border: 2px solid #10b981;
  border-radius: 50%;
}
.app-container {
}
.app-container .bot-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
}
.app-container .bot-overlay .right-modal {
  width: 380px;
  height: 100%;
  background: #fff;
  border-radius: 1rem 0 0 1rem;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 15px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.3s ease-out;
}
.app-container .bot-overlay .right-modal header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
  order: 0;
}
.app-container .bot-overlay .right-modal header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
}
.app-container .bot-overlay .right-modal header .close-btn {
  border: none;
  background: transparent;
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.2s ease;
}
.app-container .bot-overlay .right-modal header .close-btn:hover {
  color: #ef4444;
}
.app-container .bot-overlay .right-modal .chat-wrapper {
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
  background: #fff;
}
@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  70% {
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    transform: scale(0.9);
    opacity: 0;
  }
}
@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@media (max-width: 480px) {
  .bot-wrapper {
    width: 100%;
    max-height: 50%;
    border-radius: 1rem 1rem 0 0;
  }
  .bot-overlay .right-modal {
    width: 100%;
    border-radius: 0;
  }
}
/*# sourceMappingURL=ai-voice.component.css.map */
